import type {Product} from '../../cart/models/Product';
import {calculateDiscountPercentage} from '../../helpers/calculateDiscountPercentage';
import React from 'react';
import {DownloadableTable} from '../../ui/styles/DownloadableTable';
import {FormattedNumber} from "../../common/ui/FormattedNumber";

export const DownloadableProductTableUI = ({ products }) => {
  const calcTotalPrice = (product: Product): number => {
    const price = product.quantity * product.sellingPrice;
    return price + ((price * product.tax) / 100);
  };

  return (
    <DownloadableTable>
      <thead>
      <tr>
        <th>Ref.</th>
        <th>Descripción</th>
        <th>Cantidad</th>
        <th>Precio Ud(s)</th>
        <th>% IVA</th>
        <th>% Dto.</th>
        <th>Total</th>
      </tr>
      </thead>
      <tbody>
      {
        products.map((product, index) => (
          <tr key={index}>
            <td>{product.code}</td>
            <td>{!!product.name ? product.name : 'N/A'}</td>
            <td>{product.quantity}</td>
            <td><FormattedNumber value={product.sellingPrice} config={{style: "currency"}}/></td>
            <td><FormattedNumber value={product.tax} config={{style: "percent"}}/></td>
            <td><FormattedNumber value={calculateDiscountPercentage(product.basePrice, product.sellingPrice)} config={{style: "currency"}}/></td>
            <td><FormattedNumber value={calcTotalPrice(product)} config={{style: "currency"}}/></td>
          </tr>
        ))
      }
      </tbody>
    </DownloadableTable>
  );
};

